// extracted by mini-css-extract-plugin
export default {"bg":"TitleTabs_bg__bbbtV","wrapper":"TitleTabs_wrapper__Ntq0T","inner":"TitleTabs_inner__p-Rey"};